import {
  ChangeDetectorRef,
  Component,
  DoCheck,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Pipe,
  PipeTransform,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CartCustomerService } from '@parts-catalog/services/cart.customer.service';
import { WatchStorageService } from '@parts-catalog/services/watchstorage.service';
import { AuthService } from '@reusable/services/auth/auth.service';
import * as globals from '@reusable/services/globals';
import { UsersService } from '@reusable/services/users/users.service';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { interval } from 'rxjs/internal/observable/interval';
import { takeWhile } from 'rxjs/internal/operators/takeWhile';
import { from, map, take } from 'rxjs';
import { timer } from 'rxjs';

declare let $: any;
declare let imprint: any;
declare let rudderanalytics: any;

@Component({
  selector: 'sp-mobile-login',
  standalone: false,
  templateUrl: './mobile-login.component.html',
  styleUrls: ['./mobile-login.component.scss']

})
export class MobileLoginComponent implements OnInit, DoCheck, OnDestroy {
  @Input() anonymousUser: boolean;
  @Input() mobilePhoto: boolean = true;
  @Input() showBackStepButton: boolean = false;
  @Output() isAuthenticated: EventEmitter<boolean> = new EventEmitter();
  @Output() backStepHandler: EventEmitter<boolean> = new EventEmitter();
  num;
  result;
  countDown;
  remainSec;
  tick = 1000;
  counter = 90;
  codeValidate;
  mobileNum: any;
  activationcode;
  codeSent = false;
  imprintValue: any;
  closeResult: string;
  private focus = true;
  loginForm: UntypedFormGroup;
  confirmForm: UntypedFormGroup;

  showConfirmCode = false;
  validMobile: boolean = true;
  stopCondition: boolean = false;
  notValidMobileNumber: boolean = false;
  @ViewChild('mobileCode', { static: false }) mobileCode: TemplateRef<any>;
  @Inject('Window') window: Window;
  browserTests: any = [
    'audio',
    'availableScreenResolution',
    'canvas',
    'colorDepth',
    'cookies',
    'cpuClass',
    'deviceDpi',
    'doNotTrack',
    'indexedDb',
    'language',
    'localStorage',
    'pixelRatio',
    'platform',
    'plugins',
    'processorCores',
    'screenResolution',
    'sessionStorage',
    'timezoneOffset',
    'touchSupport',
    'userAgent',
    'webGl'
  ];
  currentUser: any;
  firstDigit: any;
  valid: boolean = true;
  secondDigit: any;
  counterInterval$: any;
  appURL: string;

  @Input() set autofocus(condition: boolean) {
    this.focus = condition !== false;
  }

  constructor(
    private title: Title,
    private router: Router,
    private el: ElementRef,
    private fb: UntypedFormBuilder,
    private auth: AuthService,
    private user: UsersService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private activeRoute: ActivatedRoute,
    private cartService: CartCustomerService,
    private watchStorage: WatchStorageService,
    private cookieService: CookieService
  ) {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        const pageTitle = this.title.getTitle();
      }
    });
    {
      const subscription = from(imprint.test(this.browserTests));
      subscription.subscribe(
        fingerprint => {
          this.imprintValue = fingerprint;
        },
        error => {
          console.log(error);
        }
      );
    }
  }

  public ngDoCheck() {
    this.cdr.detectChanges();
  }

  ngOnInit() {
    this.appURL = globals.appURL;
    if (this.auth.isLoggedIn()) {
      this.router.navigate(['/']);
    }
    this.title.setTitle('سبيرو | تسجيل عضوية جديدة');
    this.buildForm();
    this.buildCodeForm();

    const user = this.user.userDecodeJWT();
    if (user) {
      const user_id = user._id ? user._id : '';
      const userPayload = {
        name: `${user?.name?.first || ''} ${user?.name?.last || ''}`,
        mobile: `${user.mobile}`,
        email: user.email
      };
      if (user.email) {
        rudderanalytics.identify(user_id, userPayload);
      }
    }
  }

  /**
   * Build Login Form
   */
  buildForm(): void {
    this.loginForm = this.fb.group({
      number: ['', [Validators.required, Validators.minLength(9), Validators.maxLength(10), Validators.pattern(/[0-9\+\-\ ]/)]]
    });
  }

  checkValidation(event: any) {
    this.loginForm.valueChanges.subscribe((val: any) => {
      const value = val.number;
      [this.firstDigit, this.secondDigit] = value.toString();
      if (parseInt(this.firstDigit, 10) === 5) {
        this.valid = true;
      } else if (parseInt(this.firstDigit, 10) === 0 && parseInt(this.secondDigit, 10) === 5) {
        this.valid = true;
      } else {
        this.valid = false;
      }
    });
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
    this.loginForm.valueChanges.subscribe((val: any) => {
      const value = val.number;
      [this.firstDigit] = value.toString();
      if (parseInt(this.firstDigit, 10) === 0) {
        const editableNum = value.substr(1);
        if (editableNum && editableNum.length === 9 && editableNum > 500000000 && editableNum < 600000000) {
          this.validMobile = true;
        } else {
          this.validMobile = false;
        }
      } else if (parseInt(this.firstDigit, 10) === 5 && value && value.length === 9 && value > 500000000 && value < 600000000) {
        this.validMobile = true;
      } else {
        this.validMobile = false;
      }
    });
  }

  handleEnterKey(event) {
    if (event.keyCode === 13) {
      if (this.loginForm.valid && this.validMobile) {
        this.get_otp(event);
        this.showConfirmCode = true;
        return;
      }
      this.validateAllFormFields(this.loginForm);
      this.keyPress(event);
    }
  }

  getOTPValidator(e) {
    if (this.loginForm.valid && this.validMobile) {
      this.get_otp(e);
    }
    if (this.loginForm.valid && this.validMobile) {
      this.showConfirmCode = true;
    } else {
      this.validateAllFormFields(this.loginForm);
    }
  }
  /**
   *
   * Get Code To Mobile
   * when user send his mobile he receive code
   * by sending this code to backend user logged in
   */
  get_otp(e) {
    const mobileNumber =
      this.loginForm.value.number.charAt(0) === '0' ? this.loginForm.value.number.substring(1) : this.loginForm.value.number;
    const body = { mobile: mobileNumber };
    if (this.loginForm.valid) {
      this.notValidMobileNumber = false;
      this.auth.getOtp(body).subscribe(
        (data:any) => {
          this.result = data;
          this.num = mobileNumber;
          this.codeValidate = null;
          if (this.result.case === 1 || this.result.case === 2) {
            // this.countDownExp();
            const hms = this.result.codeExpiresAfter;
            const date = new Date(hms);
            const m = date.getMinutes();
            const s = date.getSeconds();
            const seconds = m * 60 + s;
            this.counter = seconds + 2;
            this.tick = 1000;
            this.countDownFunc();
            this.confirmForm.get('otp').enable();
          } else if (this.result.case === 4) {
            const hms = this.result.codeExpiresAfter;
            const date = new Date(hms);
            const m = date.getMinutes();
            const s = date.getSeconds();
            const seconds = m * 60 + s;
            this.counter = seconds;
            this.tick = 1000;
            this.countDownFunc();
            this.confirmForm.get('otp').enable();
          } else {
            this.confirmForm.get('otp').disable();
          }
          if (this.result.case === 0) {
            this.notValidMobileNumber = true;
          }
        },
        err => {
          // this.toastMessage = 'هذا الرقم غير صحيح.. يجب ان يكون 9 ارقام .. ولا يحتوي على حروف';
          // this.toastType = 'error';
          // this.toastr[this.toastType](this.toastMessage);
        }
      );
    }
  }

  buildCodeForm(): void {
    this.confirmForm = this.fb.group({
      otp: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern(/[0-9\+\-\ ]/)]]
    });
  }

  onlyNumberKey(event) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105)) {
      return false;
    }
  }

  countDownFunc() {
    this.stopCondition = false;
    this.countDown = timer(0, this.tick)
      .pipe(
        take(this.counter),
        map(() => this.counter));
    this.counterInterval$ = interval(1000)
      .pipe(takeWhile(() => !this.stopCondition))
      .subscribe((i: any) => {
        this.counter = this.counter - 1;
        this.remainSec = this.counter;
        if (this.remainSec === 0) {
          this.stopCondition = true;
        }
      });
  }

  sendActivationCode(event) {
    if (!event) {
      return;
    }
    let { value } = event.target;
    const arabic = /[\u0600-\u06FF]/;
    if (arabic.test(value)) {
      value = value
        .replace(/[٠١٢٣٤٥٦٧٨٩]/g, (d) => d.charCodeAt(0) - 1632)
        .replace(/[۰۱۲۳۴۵۶۷۸۹]/g, (d) => d.charCodeAt(0) - 1776);
      this.confirmForm.get('otp').setValue(value);
    }
    if (this.confirmForm.valid) {
      const body = {
        mobile: this.num,
        otp: value,
        deviceId: this.imprintValue,
        deviceType: 'Web'
      };
      this.user.sendCode(body).subscribe((response: any) => {
        this.codeValidate = response;
        if (this.codeValidate) {
          this.codeSent = true;
          if (this.codeValidate.case === 1) {
            const jwt = new JwtHelperService();
            this.currentUser = jwt.decodeToken(response.accessToken);
            if (this.currentUser.roles && this.currentUser.roles.indexOf('customer') !== -1) {
              if (response?.accessToken) {
                this.watchStorage.setItem('accessToken', response.accessToken);
                this.watchStorage.setItem('refreshToken', response.refreshToken);
                this.cookieService.set('accessToken', response.accessToken, { expires: 14, sameSite: 'Lax', secure: true });
                this.cookieService.set('refreshToken', response.refreshToken, { expires: 14, sameSite: 'Lax', secure: true });
              }
            }
            const user = this.user.userDecodeJWT();
            this.cartService.setupCart();
            this.activeRoute.queryParams.subscribe((params: any) => {
              if ('cart' in params) {
                window.location.href = `${globals.appURL}/spare-parts/cart/`;
              } else {
                if (this.anonymousUser) {
                  this.isAuthenticated.emit(true);
                } else {
                  window.location.href = `${globals.appURL}/home/requests`;
                }
              }
            });
          }
        }
      });
    } else {
      this.codeValidate = null;
    }
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  displayFieldCss(field: string) {
    return {
      'ng-touched': this.isFieldValid(field),
      'ng-invalid': this.isFieldValid(field)
    };
  }

  isFieldValid(field: string) {
    return this.loginForm && !this.loginForm.get(field).valid && this.loginForm.get(field).touched;
  }
  goBacktoEditNum() {
    this.showConfirmCode = false;
  }
  ngOnDestroy(): void {
    if (this.counterInterval$) {
      this.counterInterval$.unsubscribe();
    }
  }
  handleBackStep(event) {
    if (event) {
      this.backStepHandler.emit(true);
    }
  }
}

@Pipe({
  name: 'formatTime'

})

export class FormatTimePipe implements PipeTransform {
  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    return `${(`00${minutes}`).slice(-2)}:${(`00${Math.floor(value - minutes * 60)}`).slice(-2)}`;

  }
}